import React from 'react';

import GridItem from 'components/Grid/GridItem.js';
import Card from 'components/Card/Card.js';
import CardHeader from 'components/Card/CardHeader.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardBody from 'components/Card/CardBody.js';
import { Assignment } from '@material-ui/icons';
import { TextField } from '@material-ui/core';

export default function WriteOther(props) {
  const { inputChange, dataProduct } = props; //data Products

  return (
    <GridItem xs={12}>
      <Card>
        <CardHeader icon>
          <CardIcon color="primary">
            <Assignment />
          </CardIcon>
          <h4 style={{ color: 'black' }}>Datos</h4>
        </CardHeader>
        <CardBody>
          <TextField
            label="Comentario"
            name="UserText"
            multiline
            margin="normal"
            fullWidth
            onChange={inputChange}
            value={dataProduct.UserText || ''}
            inputProps={{
              minRows: 3
            }}
          />
        </CardBody>
      </Card>
    </GridItem>
  );
}
